import { ProductPriceTypographyStructure } from '../types';

export const TEXT_SIZE = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
    EXTRA_LARGE: 'EXTRA_LARGE',
} as const;

export const DEFAULT_TYPOGRAPHY_STRUCTURE: ProductPriceTypographyStructure = {
    [TEXT_SIZE.EXTRA_LARGE]: {
        level: '4',
        type: 'header',
    },
    [TEXT_SIZE.LARGE]: {
        level: '2',
        type: 'body',
        weight: 'bold',
    },
    [TEXT_SIZE.MEDIUM]: {
        level: '1',
        type: 'small',
    },
    [TEXT_SIZE.SMALL]: {
        level: '2',
        type: 'small',
    },
};
